import { canBridgeUse, useBridge } from '../../utils/bridge/common';
import { Picker, Toast } from '@ks/sharp-ui';
import formEventBus, { FORM_EVENTS_TYPE } from '../../utils/event-bus';

export const isPickerSupport = async () => await canBridgeUse('ui', 'showPicker');

function bridgeOptionsToPickerOption(options, group) {
    if (!Array.isArray(options)) {
        return [];
    }
    const pickerOptions = options.map(item => {
        if (Array.isArray(item)) {
            return bridgeOptionsToPickerOption(item);
        }
        if (item.subGroup) {
            return {
                ...item,
                children: bridgeOptionsToPickerOption(item.subGroup),
            };
        }
        return item;
    });
    // picker的options格式太蛋疼了，当group为true时只需要输出第一项
    return group ? pickerOptions[0] : pickerOptions;
}

export async function showPicker(param) {
    const _picker = new Promise(resolve => {
        const pickerConfig = {
            title: param.headerText,
            // fix: 空串导致默认的按钮文案不显示
            cancelText: param.cancelText || undefined,
            okText: param.okText || undefined,
            value: param.default.map(item => item.value),
            data: bridgeOptionsToPickerOption(param.data, !!param.group),
            cascade: !!param.group,
            dataKeys: {
                value: 'value',
                text: 'text',
                children: 'subGroup',
            },
            onPick: (value, valueObj) => {
                if (!value || !value.length || !value[0]) {
                    resolve(valueObj);
                    // console.log('[zy] onPick', value, valueObj);
                    Toast.error('选择过快，请重新选择！');
                }
                resolve(valueObj);
            },
        };
        // console.log(pickerConfig);
        const picker = Picker.create(pickerConfig);
        picker.showPicker();
        formEventBus.$emit(FORM_EVENTS_TYPE.IS_OPEN_PICKER, true);
        picker.$on('hide', () => {
            formEventBus.$emit(FORM_EVENTS_TYPE.IS_OPEN_PICKER, false);
        });
    });
    // 调用方自行try catch吧……
    return await _picker;
}
